import {
    UserCheck,
    ShieldCheck,
    Sofa,
    MessageCircle,
    Check,
} from "lucide-react";
import { IMAGES, FEATURES } from "../data/site";

const ICONS = [UserCheck, ShieldCheck, Sofa, MessageCircle];

export default function About() {
    return (
        <section
            id="hakkimizda"
            data-testid="about-section"
            className="section bg-[#0f0f11] border-y border-[#23232b] relative overflow-hidden"
        >
            {/* soft gold glow accents */}
            <div className="absolute top-1/4 -left-40 w-[400px] h-[400px] rounded-full bg-[#c9a24b]/8 blur-[130px] pointer-events-none" />

            <div className="container-x grid lg:grid-cols-12 gap-10 lg:gap-16 items-center relative">
                {/* Left — image (using actual exterior in a smaller professional treatment) */}
                <div className="lg:col-span-6">
                    <div className="relative">
                        <div className="absolute -inset-3 rounded-[28px] bg-gradient-to-br from-[#c9a24b]/25 to-transparent blur-lg -z-10" />
                        <div className="hero-frame aspect-[4/5] lg:aspect-[5/6] w-full">
                            <img
                                src={IMAGES.exterior}
                                alt="Cegu Masaj Salonu Özlüce — salonumuz"
                                className="w-full h-full object-cover"
                                loading="lazy"
                                style={{
                                    filter:
                                        "contrast(1.08) saturate(1.02) brightness(1.02)",
                                }}
                            />
                        </div>
                        {/* Floating stat card */}
                        <div className="hidden md:block absolute -bottom-6 -right-6 z-20 bg-[#0a0a0c] border border-[#c9a24b]/30 rounded-2xl p-5 shadow-2xl">
                            <div className="text-[10.5px] uppercase tracking-[0.24em] gold-text mb-2">
                                Kuruluş
                            </div>
                            <div className="text-3xl font-bold text-[#f4efe4]">
                                Özlüce
                            </div>
                            <div className="text-[12px] text-[#7d766a] mt-1">
                                Nilüfer, Bursa
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right — text */}
                <div className="lg:col-span-6">
                    <div className="eyebrow mb-4">Hakkımızda</div>
                    <h2 className="h2 text-[#f4efe4]">
                        Özlüce'de{" "}
                        <span className="gold-text">Konforlu ve Profesyonel</span>{" "}
                        Masaj Salonu
                    </h2>
                    <div className="divider-gold mt-6" />

                    <p className="mt-7 body-base">
                        Cegu Masaj Salonu, Bursa Nilüfer Özlüce'de Batı Palas
                        içerisinde konumlanan, kişiye uygun hizmet yaklaşımıyla
                        çalışan bir masaj salonudur. Deneyimli terapist ekibimiz,
                        klasikten medikale kadar misafirlerimizin beklentilerine
                        uygun uygulamalar sunar.
                    </p>
                    <p className="mt-4 body-base">
                        Her seansta yenilenen tekstil, akustik yalıtımlı konforlu
                        odalar ve kolay ulaşım imkânı ile şehrin yorgunluğunu
                        arkanızda bırakabileceğiniz bir alan tasarladık. WhatsApp
                        hattımız üzerinden dakikalar içinde randevunuzu
                        oluşturabilirsiniz.
                    </p>

                    <ul className="mt-8 grid grid-cols-2 gap-x-6 gap-y-2.5 text-[14px] text-[#c9c2b3]">
                        {[
                            "Hijyen standartları",
                            "Konforlu odalar",
                            "Uzman ekip",
                            "Kolay ulaşım",
                            "Kişiye uygun hizmet",
                            "Hızlı WhatsApp randevusu",
                        ].map((t) => (
                            <li
                                key={t}
                                className="inline-flex items-center gap-2"
                            >
                                <Check className="w-4 h-4 text-[#c9a24b] shrink-0" />
                                {t}
                            </li>
                        ))}
                    </ul>

                    <div className="mt-10 grid grid-cols-2 gap-3 md:gap-4">
                        {FEATURES.map((f, i) => {
                            const Icon = ICONS[i];
                            return (
                                <div
                                    key={f.title}
                                    data-testid={`feature-${i}`}
                                    className="card-flat p-4 md:p-5 hover:border-[#c9a24b]/50 transition-colors"
                                >
                                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#c9a24b] to-[#8a6a28] flex items-center justify-center mb-3 shadow-lg shadow-[#c9a24b]/20">
                                        <Icon className="w-4 h-4 text-[#0a0a0c]" />
                                    </div>
                                    <div className="text-[14.5px] font-semibold text-[#f4efe4] leading-tight">
                                        {f.title}
                                    </div>
                                    <div className="text-[12.5px] text-[#7d766a] mt-1.5 leading-snug">
                                        {f.text}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}
